<template>
  <div class="sonpage-container">
    <div class="son-main">
      <!-- 自定义配置页面 -->
      <el-tabs type="card" v-model="activeName">
        <el-tab-pane v-for="page in pages" :key="page.pageName" :label="page.name" :name="page.pageName">
          <!-- 使用动态组件渲染页面内容 -->
          <component
            :is="page.pageName"
            :ref="page.pageName"
            :wifi="wifi" @update:config-wifi="handleWifiUpdate" 
            :mobileNet="mobileNet" @update:config-mobileNet="handleMobileNetUpdate" 
            :launchers="launcher" @update:config-launcher="handleLauncherUpdate" 
            :displaySet="displaySet" @update:config-displaySet="handleDisplaySetUpdate" 
            :sound="sound" @update:config-sound="handleSoundUpdate"
            :timeSet="timeSet" @update:config-timeSet="handleTimeSetUpdate" 
            :USBSet="USBSet" @update:config-USBSet="handleUSBSetUpdate" 
            :GeneralSet="GeneralSet" @update:config-GeneralSet="handleGeneralSetUpdate" 
            :featuredSetNoFilter=featuredSetNoFilter @update:config-featuredSetFilter="handleFeaturedSetUpdate" @update:config-featuredSetNoFilter="handleFeaturedSetUpdateNoFliter"
            :scanToolDataNoFilter=scanToolDataNoFilter @update:config-scanToolDataNoFilter="handleScanToolDataUpdateNoFliter" @update:config-scanToolDataFilter="handleScanToolData" 
            :appSettingDataNoFilter="appSettingDataNoFilter" @update:config-appSettingDataNoFilter="handleAppSetDataNoFilter" @update:config-appSettingDataFilter="handleAppSettingData" 
            :mobileButler="mobileButler" @update:config-mobileButler="handleMobileButler"
            :shortCutKey="shortCutKey" @update:config-shortCutKey="handleShortCutKey"
            :isCustomPage=true />
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页脚 -->
    <div class="footer-btns">
      <footer-btn
        @resetPagesData="resetPagesData"
        @configSaveAsPlan="configSaveAsPlan"
        @customFatherPagePreviewQRCode="customFatherPagePreviewQRCode"
        @handleDownLoadCustomQRCodeImg="handleDownLoadCustomQRCodeImg"
        @handleDownLoadCustomQrCodeFile="handleDownLoadCustomQrCodeFile"
        @handlePreviewCustomQrCodeFile="handlePreviewCustomQrCodeFile"
      ></footer-btn>
    </div>
    <!-- 保存为方案组件 -->
    <save-plan
      :showPlanDialog.sync="planDialogVisible"
      :savePlanId="savePlanId"
      :saveName="saveName"
      :planType="planType"
      :fatherPlanData="fatherPlanData"
      :fatherPlanNoHandleData="fatherPlanNoHandleData"
      @handleClosePlanDialog="handleClosePlanDialog"
    ></save-plan>

    <!-- 二维码展示子组件 -->
    <qrcode-page :showDialog.sync="isQRCodeVisible" :qrCodeTxt="qrCodeTxt" :qrCodeTitle="qrCodeTitle"></qrcode-page>
  </div>
</template>
<script>
import { cloneDeep, omit, isEmpty } from "lodash";
import wifi from "@/views/menuPage/ConfigComponents/wifi.vue";
import mobileNet from "@/views/menuPage/ConfigComponents/mobileNet.vue";
import launcherSet from "@/views/menuPage/ConfigComponents/LauncherSet.vue";
import displaySet from "@/views/menuPage/ConfigComponents/DisplaySettings.vue";
import sound from "@/views/menuPage/ConfigComponents/sound.vue";
import timeSet from "@/views/menuPage/ConfigComponents/timeSetting.vue";
import USBSet from "@/views/menuPage/ConfigComponents/USBSetting.vue";
import GeneralSet from "@/views/menuPage/ConfigComponents/GeneralSettings.vue";
import featuredSet from "@/views/menuPage/ConfigComponents/FeatureSetting.vue";
import scanningTool from "@/views/menuPage/ConfigComponents/ScanTool.vue";
import dataWedge from "@/views/menuPage/ConfigComponents/dataWedge.vue";
import mobileButler from "@/views/menuPage/ConfigComponents/MobileButler.vue";
import shortCutKey from "@/views/menuPage/ConfigComponents/ShortCutKey.vue";
import manageApp from "@/views/menuPage/ManageApp.vue";
import manageFileCert from "@/views/menuPage/ManageFileCert.vue";
import footerBtn from "@/components/footerBtns.vue";
import savePlan from "@/components/saveAsPlan.vue";
import qrcodePage from "@/components/showQRCode.vue";
import QRCode from 'qrcode';
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import { downFileData, txtToQRtxt } from '@/utils/qrCodeFunctions.js';
import { EventBus } from '@/utils/event-bus';
import { removeEmptyProperty } from '@/utils';
export default {
  data() {
    // 热键设置默认值
    const defaultShortCutKey = {
      DeleteConfig: {
        BroadcastInfo: [],
      },
      BroadcastInfo: [],
      KeyMappingInfo: [],
    }
    // 移动管家默认值
    const defaultMobileButler = {
      DeleteConfig: {},
      AppList: [],
      auto_start_app: {},
      Setting: {
        account_info: {},
        password_protection: {},
      },
      wp: {},
    }
    // 特色配置默认值
    const defaultFeatureSetData = {
      softinput: {
        type: "int",
        value: null
      },
      allow_install_apps: {
        type: "int",
        value: null
      },
      scankey_awake_screen: {
        type: "int",
        value: null
      },
      vkey1_disabled: {
        type: "int",
        value: null
      },
      vkey2_disabled: {
        type: "int",
        value: null
      },
      vkey3_disabled: {
        type: "int",
        value: null
      },
      glove_mode: {
        type: "int",
        value: null
      },
      drop_down: {
        type: "int",
        value: null
      },
      scankey_code: {
        type: "int",
        value: null
      },
      scan_float: {
        type: "int",
        value: null
      },
      force_imei: {
        type: "int",
        value: null
      },
      drop_detection_disabled: {
        type: "int",
        value: null
      },
      developer_no_password: {
        type: "int",
        value: null
      },
      keypad_mode_stick_once: {
        type: "int",
        value: null
      },
      P5_disable: {
        type: "int",
        value: null
      },
      P7_disable: {
        type: "int",
        value: null
      },
      recent_transfer_menu: {
        type: "int",
        value: null
      },
      disable_key_home: {
        type: "int",
        value: null
      },
      disable_key_lockscreen: {
        type: "int",
        value: null
      },
      install_no_market_apps: {
        type: "int",
        value: null
      },
      keypadsound: {
        type: "int",
        value: null
      },
      allow_document_install_apps: {
        type: "int",
        value: null
      },
      fixed_charge_mode: {
        type: "int",
        value: null
      },
      scankey_awake_scan: {
        type: "int",
        value: null
      },
      wake_gesture_enable: {
        type: "int",
        value: null
      },
      voice_enable: {
        type: "int",
        value: null
      },
      usb_only_charge: {
        type: "int",
        value: null
      },
      screen_all_rotation: {
        type: "int",
        value: null
      },
      app_compatibility: {
        type: "int",
        value: null
      },
      scan_focus_mode_enhance: {
        type: "int",
        value: null
      },
      custom_button: {
        type: "int",
        value: null
      },
      double_click_awake_screen: {
        type: "int",
        value: null
      }
    };
    // 扫描参数
    const defaultScanToolSetData = {
      security_level: {
        type: "int",
        value: undefined,
      },
      illumination_level: {
        type: "int",
        value: null,
      },
      exp_level: {
        type: "int",
        value: null,
      },
      picklist_mode: {
        type: "int",
        value: null,
      },
      gs1_ai_separator: {
        type: "int",
        value: null,
      },
      transfer_aim_id: {
        type: "int",
        value: null,
      },
      hold_scanning_time_out: {
        type: "int",
        value: undefined,
      },
      scan_time_out: {
        type: "int",
        value: undefined,
      },
      dpm: {
        type: "int",
        value: null,
      },
      illumination_on: {
        type: "int",
        value: null,
      },
      scene_mode: {
        type: "int",
        value: null,
      },
      multi_code_number: {
        type: "int",
        value: undefined,
      },
      multi_code_timeout: {
        type: "int",
        value: undefined,
      },
      // code128
      code128: {
        type: "int",
        value: null,
      },
      code128_len_min: {
        type: "int",
        value: undefined,
      },
      code128_len_max: {
        type: "int",
        value: undefined,
      },
      isbt128: {
        type: "int",
        value: null,
      },
      gs1128: {
        type: "int",
        value: null,
      },
      code128_quiet_zone: {
        type: "int",
        value: null,
      },
      c128_inverse: {
        type: "int",
        value: null,
      },
      c128_decoding_rate_enhance: {
        type: "int",
        value: null,
      },
      // UPC/EAN
      upca: {
        type: "int",
        value: null,
      },
      upce: {
        type: "int",
        value: null,
      },
      upce1: {
        type: "int",
        value: null,
      },
      ean8: {
        type: "int",
        value: null,
      },
      ean13: {
        type: "int",
        value: null,
      },
      upca_chk: {
        type: "int",
        value: null,
      },
      upce_chk: {
        type: "int",
        value: null,
      },
      ean13_chk_send: {
        type: "int",
        value: null,
      },
      ean8_chk_send: {
        type: "int",
        value: null,
      },
      upca_pream: {
        type: "int",
        value: null,
      },
      upce_pream: {
        type: "int",
        value: null,
      },
      upce_expanded: {
        type: "int",
        value: null,
      },
      upca_2char_addenda: {
        type: "int",
        value: null,
      },
      upca_5char_addenda: {
        type: "int",
        value: null,
      },
      upce_2char_addenda: {
        type: "int",
        value: null,
      },
      upce_5char_addenda: {
        type: "int",
        value: null,
      },
      ean13_2char_addenda: {
        type: "int",
        value: null,
      },
      ean13_5char_addenda: {
        type: "int",
        value: null,
      },
      ean8_2char_addenda: {
        type: "int",
        value: null,
      },
      ean8_5char_addenda: {
        type: "int",
        value: null,
      },
      upc_ean_quiet_zone: {
        type: "int",
        value: null,
      },
      upc_inverse: {
        type: "int",
        value: null,
      },
      ean_decoding_rate_enhance: {
        type: "int",
        value: null,
      },
      //code 39
      code39: {
        type: "int",
        value: null,
      },
      code39_full_ascii: {
        type: "int",
        value: null,
      },
      code39_len_min: {
        type: "int",
        value: undefined,
      },
      code39_len_max: {
        type: "int",
        value: undefined,
      },
      code39_chk: {
        type: "int",
        value: null,
      },
      code39_ver: {
        type: "int",
        value: null,
      },
      code39_start_stop: {
        type: "int",
        value: null,
      },
      code39_quiet_zone: {
        type: "int",
        value: null,
      },
      code39_inverse: {
        type: "int",
        value: null,
      },
      c39_decoding_rate_enhance: {
        type: "int",
        value: null,
      },
      // code 93
      code93: {
        type: "int",
        value: null,
      },
      code93_len_min: {
        type: "int",
        value: undefined,
      },
      code93_len_max: {
        type: "int",
        value: undefined,
      },
      code93_quiet_zone: {
        type: "int",
        value: null,
      },
      code93_inverse: {
        type: "int",
        value: null,
      },
      // code11
      code11: {
        type: "int",
        value: null,
      },
      code11_len_min: {
        type: "int",
        value: undefined,
      },
      code11_len_max: {
        type: "int",
        value: undefined,
      },
      code11_chk_ver: {
        type: "int",
        value: null,
      },
      code11_chk: {
        type: "int",
        value: null,
      },
      // inter2to5
      i25: {
        type: "int",
        value: null,
      },
      i25_len_min: {
        type: "int",
        value: undefined,
      },
      i25_len_max: {
        type: "int",
        value: undefined,
      },
      i25_chk: {
        type: "int",
        value: null,
      },
      i25_quiet_zone: {
        type: "int",
        value: null,
      },
      i25_inverse: {
        type: "int",
        value: null,
      },
      i25_to_ean13: {
        type: "int",
        value: null,
      },
      // codabar
      codabar: {
        type: "int",
        value: null,
      },
      codabar_len_min: {
        type: "int",
        value: undefined,
      },
      codabar_len_max: {
        type: "int",
        value: undefined,
      },
      codabar_stop_start: {
        type: "int",
        value: null,
      },
      codabar_quiet_zone: {
        type: "int",
        value: null,
      },
      codabar_inverse: {
        type: "int",
        value: null,
      },
      // NEC2to5
      nec25: {
        type: "int",
        value: null,
      },
      nec25_len_min: {
        type: "int",
        value: undefined,
      },
      nec25_len_max: {
        type: "int",
        value: undefined,
      },
      // MSI
      msi: {
        type: "int",
        value: null,
      },
      msi_len_min: {
        type: "int",
        value: undefined,
      },
      msi_len_max: {
        type: "int",
        value: undefined,
      },
      // RSS
      rss14: {
        type: "int",
        value: null,
      },
      rss_limit: {
        type: "int",
        value: null,
      },
      rss_expanded: {
        type: "int",
        value: null,
      },
      // QRCode
      qrcode: {
        type: "int",
        value: null,
      },
      qrcode_len_min: {
        type: "int",
        value: undefined,
      },
      qrcode_len_max: {
        type: "int",
        value: undefined,
      },
      qrinverse: {
        type: "int",
        value: null,
      },
      microqr: {
        type: "int",
        value: null,
      },
      qrmirror: {
        type: "int",
        value: null,
      },
      microqrinverse: {
        type: "int",
        value: null,
      },
      qr_quiet_zone: {
        type: "int",
        value: null,
      },
      // data matrix
      dm: {
        type: "int",
        value: null,
      },
      dm_len_min: {
        type: "int",
        value: undefined,
      },
      dm_len_max: {
        type: "int",
        value: undefined,
      },
      // chinapost
      chinapost: {
        type: "int",
        value: null,
      },
      chinapost_len_min: {
        type: "int",
        value: undefined,
      },
      chinapost_len_max: {
        type: "int",
        value: undefined,
      },
      // m2to5
      m25: {
        type: "int",
        value: null,
      },
      m25_len_min: {
        type: "int",
        value: undefined,
      },
      m25_len_max: {
        type: "int",
        value: undefined,
      },
      // composite
      composite_upcean: {
        type: "int",
        value: null,
      },
      // pdf417
      pdf417: {
        type: "int",
        value: null,
      },
      pdf417_len_min: {
        type: "int",
        value: undefined,
      },
      pdf417_len_max: {
        type: "int",
        value: undefined,
      },
      pdf417_inverse: {
        type: "int",
        value: null,
      },
      pdf417_decoding_rate_enhance: {
        type: "int",
        value: null,
      },
      // microPDF417
      micropdf417: {
        type: "int",
        value: null,
      },
      micropdf417_len_min: {
        type: "int",
        value: undefined,
      },
      micropdf417_len_max: {
        type: "int",
        value: undefined,
      },
      // maxicode
      maxicode: {
        type: "int",
        value: null,
      },
      maxicode_len_min: {
        type: "int",
        value: undefined,
      },
      maxicode_len_max: {
        type: "int",
        value: undefined,
      },
      // aztec
      azteccode: {
        type: "int",
        value: null,
      },
      azteccode_len_min: {
        type: "int",
        value: undefined,
      },
      azteccode_len_max: {
        type: "int",
        value: undefined,
      },
      // codeablockF
      codeblockf: {
        type: "int",
        value: null,
      },
      codeblockf_len_min: {
        type: "int",
        value: undefined,
      },
      codeblockf_len_max: {
        type: "int",
        value: undefined,
      },
      // telepen
      telepen: {
        type: "int",
        value: null,
      },
      telepen_len_min: {
        type: "int",
        value: undefined,
      },
      telepen_len_max: {
        type: "int",
        value: undefined,
      },
      // ocr
      ocr: {
        type: "int",
        value: null,
      },
      ocr_template: {
        type: "int",
        value: null,
      },
      qrc_template: {
        type: "string",
        value: null,
      },
      // Hanxin
      hanxin: {
        type: "int",
        value: null,
      },
    };
    // 应用设置
    const defaultAppSetData = {
      play_sound: {
        type: "boolean",
        value: "",
      },
      play_scan_led: {
        type: "boolean",
        value: "",
      },
      vibrate: {
        type: "boolean",
        value: "",
      },
      append: {
        type: "boolean",
        value: "",
      },
      auto_clear: {
        type: "boolean",
        value: "",
      },
      boot_start: {
        type: "boolean",
        value: "",
      },
      show_barcode_type: {
        type: "boolean",
        value: "",
      },
      filter_invisible_chars: {
        type: "boolean",
        value: "",
      },
      convert_invisible_chars: {
        type: "boolean",
        value: "",
      },
      filter_prefix_suffix_blank: {
        type: "boolean",
        value: "",
      },
      ope_scan_statistics: {
        type: "boolean",
        value: "",
      },
      show_barcode_toast: {
        type: "boolean",
        value: "",
      },
      show_multi_code_scan_float: {
        type: "boolean",
        value: "",
      },
      suffix: {
        type: "string",
        value: "",
      },
      prefix: {
        type: "string",
        value: "",
      },
      end_char: {
        type: "string",
        value: "",
      },
      charset: {
        type: "string",
        value: "",
      },
      advanced_trigger_mode: {
        type: "int",
        value: "",
      },
      send_mode: {
        type: "string",
        value: "",
      },
      barcode_broadcast_name: {
        type: "string",
        value: "",
      },
      barcode_broadcast_key: {
        type: "string",
        value: "",
      },
      start_scan_broadcast_name: {
        type: "string",
        value: "",
      },
      start_stop_broadcast_name: {
        type: "string",
        value: "",
      },
      end_event: {
        type: "boolean",
        value: "",
      },
      block_scan_key_list: {
        type: "string",
        value: "",
      },
      password_md5: {
        type: "string",
        value: "",
      },
      end_char_on_emu: {
        type: "boolean",
        value: ""
      },
      auto_commit_on_emu: {
        type: "boolean",
        value: ""
      },
      // 多条码
      multi_code_splicing: {
        multi_code_normal_splicing: {
          type: "boolean",
          value: "",
        },
        multi_code_normal_separator: {
          type: "string",
          value: "",
        },
        multi_code_gs1128_splicing: {
          type: "boolean",
          value: "",
        },
        multi_code_gs1128_separator: {
          type: "string",
          value: "",
        },
      },
      // 条码截断
      split_barcode: {
        split_barcode_mode: {
          type: "int",
          value: "",
        },
        start_index: {
          type: "int",
          value: "",
        },
        end_index: {
          type: "int",
          value: "",
        },
        start_char: {
          type: "string",
          value: "",
        },
        end_char: {
          type: "string",
          value: "",
        },
      },
      // 循环扫描
      scan_continue_internal_params: {
        scan_continue_internal_mode: {
          type: "int",
          value: "",
        },
        scan_continue_normal_internal: {
          type: "int",
          value: "",
        },
        scan_continue_no_data_internal: {
          type: "int",
          value: "",
        },
        scan_continue_with_data_internal: {
          type: "int",
          value: "",
        },
      },
      // 字符替换
      replace_string: []
    }
    const defaultWifi = { w: [], bl: [], sl: [] };
    const defaultLauncher = { l: '' };
    const defaultMobileNet = {};
    const defaultDisplay = {};
    const defaultSound = {};
    const defaultTimeSet = {};
    const defaultUSBSet = {};
    const defaultGeneralSet = {};
    const wifiData = localStorage.getItem('config-wifi') ? JSON.parse(localStorage.getItem('config-wifi')) : defaultWifi;
    const mobileNetData = localStorage.getItem('config-mobileNet') ? JSON.parse(localStorage.getItem('config-mobileNet')) : defaultMobileNet;
    const launcherData = localStorage.getItem('config-launcher') ? JSON.parse(localStorage.getItem('config-launcher')) : defaultLauncher;
    const displaySetData = localStorage.getItem('config-displaySet') ? JSON.parse(localStorage.getItem('config-displaySet')) : defaultDisplay;
    const soundData = localStorage.getItem('config-sound') ? JSON.parse(localStorage.getItem('config-sound')) : defaultSound;
    const timeSetData = localStorage.getItem('config-timeSet') ? JSON.parse(localStorage.getItem('config-timeSet')) : defaultTimeSet;
    const USBSetData = localStorage.getItem('config-USBSet') ? JSON.parse(localStorage.getItem('config-USBSet')) : defaultUSBSet;
    const GeneralSetData = localStorage.getItem('config-GeneralSet') ? JSON.parse(localStorage.getItem('config-GeneralSet')) : defaultGeneralSet;
    const featuredSetNoFilter = localStorage.getItem('config-featuredSetNoFilter') ? JSON.parse(localStorage.getItem('config-featuredSetNoFilter')) : defaultFeatureSetData;
    const scanToolData = localStorage.getItem('config-scanToolDataNoFilter') ? JSON.parse(localStorage.getItem('config-scanToolDataNoFilter')) : defaultScanToolSetData;
    const appSetData = localStorage.getItem('config-appSettingDataNoFilter') ? JSON.parse(localStorage.getItem('config-appSettingDataNoFilter')) : defaultAppSetData;
    const mobileButlerData = localStorage.getItem('config-mobileButler') ? JSON.parse(localStorage.getItem('config-mobileButler')) : defaultMobileButler;
    const shortCutKeyData = localStorage.getItem('config-shortCutKey') ? JSON.parse(localStorage.getItem('config-shortCutKey')) : cloneDeep(defaultShortCutKey);
    return {
      defaultFeatureSetData,
      defaultScanToolSetData,
      defaultAppSetData,
      defaultWifi,
      defaultLauncher,
      defaultMobileNet,
      defaultDisplay,
      defaultSound,
      defaultTimeSet,
      defaultUSBSet,
      defaultGeneralSet,
      defaultMobileButler,
      defaultShortCutKey,
      activeName: '', // 当前激活的标签页名称
      pages: [], // 页面列表，包含页面名称和组件名称
      // 保存方案参数
      planDialogVisible: false, // 保存方案对话框显示控制
      planType: 5, // 方案类型，默认为5（自定义配置方案）1:展示配置常用参数 4:展示停用系统功能项 5:展示自定义配置模式
      fatherPlanData: {}, // 已处理的数据（供第三方外部使用）
      fatherPlanNoHandleData: {}, // 未处理的数据（供组件内部使用）
      // 路由传来的保存方案数据
      savePlanId: '', // 方案id
      saveName: '', // 方案名称
      isQRCodeVisible: false, // 控制二维码展示组件的显示
      qrCodeTxt: "", // 二维码文本内容
      qrCodeTitle: '', // 二维码标题
      // wifi数据
      wifi: {
        ...cloneDeep(wifiData)
      },
      // 移动网络
      mobileNet: {
        ...cloneDeep(mobileNetData)
      },
      // 启动器数据
      launcher: {
        ...cloneDeep(launcherData)
      },
      // 显示数据
      displaySet: {
        ...cloneDeep(displaySetData)
      },
      // 声音数据
      sound: {
        ...cloneDeep(soundData)
      },
      // 时间数据
      timeSet: {
        ...cloneDeep(timeSetData)
      },
      // USB数据
      USBSet: {
        ...cloneDeep(USBSetData)
      },
      // 通用设置
      GeneralSet: {
        ...cloneDeep(GeneralSetData)
      },
      // 功能设置
      featuredSetNoFilter: {
        ...cloneDeep(featuredSetNoFilter)
      },
      // 扫描工具
      scanToolDataNoFilter: {
        ...cloneDeep(scanToolData)
      },
      // 应用设置
      appSettingDataNoFilter: {
        ...cloneDeep(appSetData)
      },
      // 移动管家
      mobileButler: {
        ...cloneDeep(mobileButlerData)
      },
      // 快捷配置
      shortCutKey: {
        ...cloneDeep(shortCutKeyData)
      },
    };
  },
  watch: {
    wifi: {
      handler(newVal) {
        localStorage.setItem('config-wifi', JSON.stringify(newVal));
      },
      deep: true
    },
    mobileNet: {
      handler(newVal) {
        localStorage.setItem('config-mobileNet', JSON.stringify(newVal));
      },
      deep: true
    },
    launcher: {
      handler(newVal) {
        localStorage.setItem('config-launcher', JSON.stringify(newVal));
      },
      deep: true
    },
    displaySet: {
      handler(newVal) {
        localStorage.setItem('config-displaySet', JSON.stringify(newVal));
      },
      deep: true
    },
    sound: {
      handler(newVal) {
        localStorage.setItem('config-sound', JSON.stringify(newVal));
      },
      deep: true
    },
    timeSet: {
      handler(newVal) {
        localStorage.setItem('config-timeSet', JSON.stringify(newVal));
      },
      deep: true
    },
    USBSet: {
      handler(newVal) {
        localStorage.setItem('config-USBSet', JSON.stringify(newVal));
      },
      deep: true
    },
    GeneralSet: {
      handler(newVal) {
        localStorage.setItem('config-GeneralSet', JSON.stringify(newVal));
      },
      deep: true
    },
    featuredSetNoFilter: {
      handler(newVal) {
        localStorage.setItem('config-featuredSetNoFilter', JSON.stringify(newVal));
      },
      deep: true
    },
    scanToolDataNoFilter: {
      handler(newVal) {
        localStorage.setItem('config-scanToolDataNoFilter', JSON.stringify(newVal));
      },
      deep: true
    },
    appSettingDataNoFilter: {
      handler(newVal) {
        localStorage.setItem('config-appSettingDataNoFilter', JSON.stringify(newVal));
      },
      deep: true
    },
    mobileButler: {
      handler(newVal) {
        localStorage.setItem('config-mobileButler', JSON.stringify(newVal));
      },
      deep: true
    },
    shortCutKey: {
      handler(newVal) {
        localStorage.setItem('config-shortCutKey', JSON.stringify(newVal));
      },
      deep: true
    },
  },
  components: {
    wifi,
    mobileNet,
    launcherSet,
    displaySet,
    sound,
    timeSet,
    USBSet,
    GeneralSet,
    featuredSet,
    scanningTool,
    dataWedge,
    mobileButler,
    shortCutKey,
    manageFileCert,
    manageApp,
    footerBtn,
    savePlan,
    qrcodePage
  },
  methods: {
    // 关闭保存方案对话框
    handleClosePlanDialog(val) {
      this.planDialogVisible = val;
    },
    // wifi数据
    handleWifiUpdate(updatedObject) {
      this.wifi = updatedObject;
    },
    // 处理mobileNet数据
    handleMobileNetUpdate(data) {
      this.mobileNet = data;
    },
    // 处理launcher数据
    handleLauncherUpdate(data) {
      this.launcher = data;
    },
    // 处理displaySet数据
    handleDisplaySetUpdate(data) {
      this.displaySet = data;
    },
    // 处理sound数据
    handleSoundUpdate(data) {
      this.sound = data;
    },
    // 处理timeSet数据
    handleTimeSetUpdate(data) {
      this.timeSet = data;
    },
    // 处理USBSet数据
    handleUSBSetUpdate(data) {
      this.USBSet = data;
    },
    // 处理GeneralSet数据
    handleGeneralSetUpdate(data) {
      this.GeneralSet = data;
    },
    // 处理featuredSet数据已过滤
    handleFeaturedSetUpdate(data) {
      localStorage.setItem('config-featuredSetFilter', JSON.stringify(data))
    },
    // 处理featuredSet数据未过滤
    handleFeaturedSetUpdateNoFliter(data) {
      this.featuredSet = data;
    },
    // 处理scanToolData数据未过滤
    handleScanToolDataUpdateNoFliter(data) {
      this.scanToolDataNoFilter = data;
    },
    // 处理scanTool数据已过滤
    handleScanToolData(data) {
      localStorage.setItem('config-scanToolDataFilter', JSON.stringify(data))
    },
    // 处理应用设置未过滤数据
    handleAppSetDataNoFilter(data) {
      this.appSettingDataNoFilter = data;
    },
    // 处理应用设置已过滤数据
    handleAppSettingData(data) {
      localStorage.setItem('config-appSetDataFilter', JSON.stringify(data));
    },
    // 处理移动管家数据
    handleMobileButler(data) {
      localStorage.setItem('config-mobileButler', JSON.stringify(data));
    },
    // 处理快捷配置数据
    handleShortCutKey(data) {
      localStorage.setItem('config-shortCutKey', JSON.stringify(data));
    },
    // 清空对应页面的数据
    resetPagesData() {
      switch (this.activeName) {
        case 'wifi':
          localStorage.removeItem('config-wifi');
          this.wifi = { w: [], bl: [], sl: [] };
          this.$message.success(this.$t('messageAdd.custom.039'));
          break;
        case 'mobileNet':
          localStorage.removeItem('config-mobileNet');
          this.mobileNet = {};
          this.$message.success(this.$t('messageAdd.custom.039'));
          break;
        case 'launcherSet':
          localStorage.removeItem('config-launcher');
          this.launcher = { l: '' };
          this.$message.success(this.$t('messageAdd.custom.039'));
          break;
        case 'displaySet':
          localStorage.removeItem('config-displaySet');
          this.displaySet = {};
          this.$message.success(this.$t('messageAdd.custom.039'));
          break;
        case 'sound':
          localStorage.removeItem('config-sound');
          this.sound = {};
          this.$message.success(this.$t('messageAdd.custom.039'));
          break;
        case 'timeSet':
          localStorage.removeItem('config-timeSet');
          this.timeSet = {}
          this.$message.success(this.$t('messageAdd.custom.039'));
          break;
        case 'USBSet':
          localStorage.removeItem('config-USBSet');
          this.USBSet = {}
          this.$message.success(this.$t('messageAdd.custom.039'));
          break;
        case 'GeneralSet':
          localStorage.removeItem('config-GeneralSet');
          this.GeneralSet = {}
          this.$message.success(this.$t('messageAdd.custom.039'));
          break;
        case 'featuredSet':
          localStorage.removeItem('config-featuredSetFilter');
          localStorage.removeItem('config-featuredSetNoFilter');
          this.featuredSetNoFilter = cloneDeep(this.defaultFeatureSetData);
          this.$message.success(this.$t('messageAdd.custom.039'));
          break;
        case 'scanningTool':
          localStorage.removeItem('config-scanToolDataNoFilter');
          localStorage.removeItem('config-scanToolDataFilter');
          this.scanToolDataNoFilter = cloneDeep(this.defaultScanToolSetData);
          localStorage.removeItem('config-appSettingDataNoFilter');
          localStorage.removeItem('config-appSetDataFilter');
          this.appSettingDataNoFilter = cloneDeep(this.defaultAppSetData);
          this.$message.success(this.$t('messageAdd.custom.039'));
          // 应用设置页也需要重置
          break;
        case 'dataWedge':
          EventBus.$emit('clearDWdata');
          break;
        case 'manageFileCert':
          localStorage.removeItem('mf');
          EventBus.$emit('clearMFdata');
          this.$message.success(this.$t('messageAdd.custom.039'));
          break;
        case 'manageApp':
          localStorage.removeItem('ma');
          EventBus.$emit('clearMAdata');
          this.$message.success(this.$t('messageAdd.custom.039'));
          break;
        case 'mobileButler':
          localStorage.removeItem('config-mobileButler');
          this.mobileButler = cloneDeep(this.defaultMobileButler);
          this.$message.success(this.$t('messageAdd.custom.039'));
          break;
        case 'shortCutKey':
          localStorage.removeItem('config-shortCutKey');
          this.shortCutKey = cloneDeep(this.defaultShortCutKey);
          this.$message.success(this.$t('messageAdd.custom.039'));
          break;
      }
    },
    // 兼容旧版 shortCutKey 对象结构数据
    // migrateShortCutKeyIfNeeded() {
    //   const dataStr = localStorage.getItem('config-shortCutKey');
    //   if (!dataStr) return;
    //   try {
    //     const data = JSON.parse(dataStr);
    //     let migrated = false;
    //     if (data.DeleteConfig && data.DeleteConfig.BroadcastInfo && !Array.isArray(data.DeleteConfig.BroadcastInfo)) {
    //       data.DeleteConfig.BroadcastInfo = Object.keys(data.DeleteConfig.BroadcastInfo).map(name => ({ name }));
    //       migrated = true;
    //     }
    //     if (data.BroadcastInfo && !Array.isArray(data.BroadcastInfo)) {
    //       data.BroadcastInfo = Object.entries(data.BroadcastInfo).map(([name, value]) => ({ name, ...value }));
    //       migrated = true;
    //     }
    //     if (data.KeyMappingInfo && !Array.isArray(data.KeyMappingInfo)) {
    //       data.KeyMappingInfo = Object.entries(data.KeyMappingInfo).map(([key, value]) => ({ key, ...value }));
    //       migrated = true;
    //     }
    //     if (migrated) {
    //       localStorage.setItem('config-shortCutKey', JSON.stringify(data));
    //       this.shortCutKey = { ...this.shortCutKey, ...data };
    //     }
    //   } catch (e) {
    //     console.error('migrateShortCutKeyIfNeeded error:', e);
    //   }
    // },
    // 将UI数组结构转换为外部需要的对象结构(针对shortCutKey数据结构特殊处理)
    transformShortCutKeyToExternal(data) {
      const result = {};
      if (data.id !== undefined) {
        result.id = data.id;
      }
      // DeleteConfig
      if (data.DeleteConfig) {
        result.DeleteConfig = {};
        if (data.DeleteConfig.delete_all !== undefined) {
          result.DeleteConfig.delete_all = data.DeleteConfig.delete_all;
        }
        if (data.DeleteConfig.delete_key_mapping_info !== undefined) {
          result.DeleteConfig.delete_key_mapping_info = data.DeleteConfig.delete_key_mapping_info;
        }
        if (data.DeleteConfig.delete_broadcast_info !== undefined) {
          result.DeleteConfig.delete_broadcast_info = data.DeleteConfig.delete_broadcast_info;
        }
        if (data.DeleteConfig.BroadcastInfo && Array.isArray(data.DeleteConfig.BroadcastInfo) && data.DeleteConfig.BroadcastInfo.length > 0) {
          result.DeleteConfig.BroadcastInfo = {};
          data.DeleteConfig.BroadcastInfo.forEach(item => {
            if (item.name) {
              result.DeleteConfig.BroadcastInfo[item.name] = null;
            }
          });
        }
      }
      // BroadcastInfo
      if (data.BroadcastInfo && Array.isArray(data.BroadcastInfo) && data.BroadcastInfo.length > 0) {
        result.BroadcastInfo = {};
        data.BroadcastInfo.forEach(item => {
          if (item.name) {
            const broadcast = {
              action: item.action || '',
              package_name: item.package_name || '',
              class_name: item.class_name || ''
            };
            if (item.parameters && Array.isArray(item.parameters) && item.parameters.length > 0) {
              broadcast.parameters = {};
              item.parameters.forEach(param => {
                if (param.name) {
                  broadcast.parameters[param.name] = {
                    type: param.type,
                    value: param.value
                  };
                }
              });
            }
            result.BroadcastInfo[item.name] = broadcast;
          }
        });
      }
      // KeyMappingInfo
      if (data.KeyMappingInfo && Array.isArray(data.KeyMappingInfo) && data.KeyMappingInfo.length > 0) {
        result.KeyMappingInfo = {};
        data.KeyMappingInfo.forEach(item => {
          if (item.key) {
            const mapping = { type: item.type };
            if (item.type === 'OTHER_KEYCODE') {
              mapping.virtual_key = item.virtual_key || '';
            }
            if (item.type === 'BROADCAST') {
              mapping.broadcast_name = item.broadcast_name || '';
            }
            if (item.type === 'APPLICATION') {
              mapping.package_name = item.package_name || '';
              mapping.class_name = item.class_name || '';
            }
            result.KeyMappingInfo[item.key] = mapping;
          }
        });
      }
      return result;
    },
    // 保存为方案
    configSaveAsPlan() {
      // 校验 mobileButler 联动必填字段
      const mobileButlerRef = this.$refs.mobileButler;
      const mobileButlerInstance = Array.isArray(mobileButlerRef) ? mobileButlerRef[0] : mobileButlerRef;
      if (mobileButlerInstance && typeof mobileButlerInstance.validateRequiredFields === 'function' && !mobileButlerInstance.validateRequiredFields()) {
        return;
      }
      const configData = this.handleCustomData();
      const front = {
        'config-wifi': localStorage.getItem('config-wifi') ? JSON.parse(localStorage.getItem('config-wifi')) : cloneDeep(this.defaultWifi),
        'config-mobileNet': localStorage.getItem('config-mobileNet') ? JSON.parse(localStorage.getItem('config-mobileNet')) : cloneDeep(this.defaultMobileNet),
        'config-launcher': localStorage.getItem('config-launcher') ? JSON.parse(localStorage.getItem('config-launcher')) : cloneDeep(this.defaultLauncher),
        'config-displaySet': localStorage.getItem('config-displaySet') ? JSON.parse(localStorage.getItem('config-displaySet')) : cloneDeep(this.defaultDisplay),
        'config-sound': localStorage.getItem('config-sound') ? JSON.parse(localStorage.getItem('config-sound')) : cloneDeep(this.defaultSound),
        'config-timeSet': localStorage.getItem('config-timeSet') ? JSON.parse(localStorage.getItem('config-timeSet')) : cloneDeep(this.defaultTimeSet),
        'config-USBSet': localStorage.getItem('config-USBSet') ? JSON.parse(localStorage.getItem('config-USBSet')) : cloneDeep(this.defaultUSBSet),
        'config-GeneralSet': localStorage.getItem('config-GeneralSet') ? JSON.parse(localStorage.getItem('config-GeneralSet')) : cloneDeep(this.defaultGeneralSet),
        'config-featuredSetNoFilter': localStorage.getItem('config-featuredSetNoFilter') ? JSON.parse(localStorage.getItem('config-featuredSetNoFilter')) : cloneDeep(this.defaultFeatureSetData),
        'config-scanToolDataNoFilter': localStorage.getItem('config-scanToolDataNoFilter') ? JSON.parse(localStorage.getItem('config-scanToolDataNoFilter')) : cloneDeep(this.defaultScanToolSetData),
        'config-appSettingDataNoFilter': localStorage.getItem('config-appSettingDataNoFilter') ? JSON.parse(localStorage.getItem('config-appSettingDataNoFilter')) : cloneDeep(this.defaultAppSetData),
        'config-editableTabs': localStorage.getItem('config-editableTabs') ? JSON.parse(localStorage.getItem('config-editableTabs')) : {},
        'config-dataWedgeApp': localStorage.getItem('config-dataWedgeApp') ? JSON.parse(localStorage.getItem('config-dataWedgeApp')) : {},
        'ma': localStorage.getItem('ma') ? JSON.parse(localStorage.getItem('ma')) : {},
        'mf': localStorage.getItem('mf') ? JSON.parse(localStorage.getItem('mf')) : {},
        'config-mobileButler': localStorage.getItem('config-mobileButler') ? JSON.parse(localStorage.getItem('config-mobileButler')) : cloneDeep(this.defaultMobileButler),
        'config-shortCutKey': localStorage.getItem('config-shortCutKey') ? JSON.parse(localStorage.getItem('config-shortCutKey')) : cloneDeep(this.defaultShortCutKey),
        pages: this.pages
      }
      // 调用接口传方案至后端
      this.planDialogVisible = true;
      this.fatherPlanData = configData;
      this.fatherPlanNoHandleData = front;//未处理数据
    },
    // 处理数据
    handleCustomData() {
      const configKeys = {
        'wifi': 'config-wifi',
        'launcher': 'config-launcher',
        'mobileNet': 'config-mobileNet',
        'displaySet': 'config-displaySet',
        'sound': 'config-sound',
        'timeSet': 'config-timeSet',
        'USBSet': 'config-USBSet',
        'GeneralSet': 'config-GeneralSet',
        'featuredSet': 'config-featuredSetFilter',
        'scanningTool': 'config-scanToolDataFilter', // 
        'dataWedge': 'config-dataWedgeApp', // 
        'manageApp': 'ma',
        'manageFileCert': 'mf',
        'mobileButler': 'config-mobileButler',
        'shortCutKey': 'config-shortCutKey'
      };
      // 初始化一个空对象来存储处理后的数据
      let commonData = {};
      const getKeyForPageName = (pageName) => {
        switch (pageName) {
          case 'wifi':
            return 'w';
          case 'launcher':
            return 'ls';
          case 'mobileNet':
            return 'm';
          case 'displaySet':
            return 'd';
          case 'sound':
            return 'v';
          case 'timeSet':
            return 't';
          case 'USBSet':
            return 'u';
          case 'GeneralSet':
            return 'c';
          case 'featuredSet':
            return 'fs';
          case 'scanningTool':
            return 'st';
          case 'dataWedge':
            return 'dw';
          case 'manageApp':
            return 'ma';
          case 'manageFileCert':
            return 'mf';
          case 'mobileButler':
            return 'MobileButler';
          case 'shortCutKey':
            return 'ShortCutKey';
          default:
            console.warn(`Unknown pageName: ${pageName}`);
            return null;
        }
      };
      this.pages.forEach((item, index) => {
        if (item.pageName === 'dataWedge') {//处理dataWedge
          const dwData = localStorage.getItem('config-dataWedgeApp');
          const dwConfig = localStorage.getItem('config-editableTabs');
          if (dwConfig || dwData) {
            try {
              const cleanedData = this.handleDataWedgeQrCodeData(JSON.parse(dwConfig));
              commonData.dw = {
                c: {
                  dwSetting: { ...JSON.parse(dwData) },
                  configList: [
                    ...cleanedData
                  ]
                },
                id: index + 1
              }; // 将处理后的数据添加到 commonData 中
            } catch (error) {
              console.error(`Error parsing data for ${item.pageName}:`, error);
            }
          }
        } else if (item.pageName === 'scanningTool') {//处理scanningTool
          const sdata = localStorage.getItem('config-scanToolDataFilter');
          const adata = localStorage.getItem('config-appSetDataFilter');
          if (sdata != null || adata != null) {
            try {
              const parsedSData = JSON.parse(sdata);
              const parsedAData = JSON.parse(adata);
              commonData.st = {
                c: {
                  ScanTool: { ...parsedSData },
                  AppSetting: { ...parsedAData }
                },
                id: index + 1
              }
            } catch (error) {
              console.error(`Error parsing data for ${item.pageName}:`, error);
            }
          }
        } else if (item.pageName === 'featuredSet') {//处理featuredSet
          const dataKey = configKeys[item.pageName];
          const data = localStorage.getItem(dataKey);
          if (data) {
            try {
              const parsedData = JSON.parse(data);
              const key = getKeyForPageName(item.pageName); // 获取转换后的键名
              commonData[key] = { 
                c: { ...parsedData }, 
                id: index + 1 
              };
            } catch (error) {
              console.error(`Error parsing data for ${item.pageName}:`, error);
            }
          }
        } else if(item.pageName === 'mobileButler') {// 处理mobileButler
          const dataKey = configKeys[item.pageName];
          const data = localStorage.getItem(dataKey);
          if (data) {
            try {
              const parsedData = JSON.parse(data);
              const key = getKeyForPageName(item.pageName); // 获取转换后的键名
              commonData[key] = {
                c: { MobileButler: removeEmptyProperty(omit(parsedData, ['wp'])) },
                id: index + 1
              }
              if (!isEmpty(parsedData.wp)) {
                commonData[key].wp = parsedData.wp;
              }
            } catch (error) {
              console.error(`Error parsing data for ${item.pageName}:`, error);
            }
          }
        } else if(item.pageName === 'shortCutKey') {// 处理shortCutKey
          const dataKey = configKeys[item.pageName];
          const data = localStorage.getItem(dataKey);
          if (data) {
            try {
              const parsedData = JSON.parse(data);
              const cleanedData = this.transformShortCutKeyToExternal(parsedData);
              const key = getKeyForPageName(item.pageName); // 获取转换后的键名
              commonData[key] = { 
                c: { ShortCutKey: { ...cleanedData } },
                id: index + 1 
              };
            } catch (error) {
              console.error(`Error parsing data for ${item.pageName}:`, error);
            }
          }
        } else if (configKeys[item.pageName]) {//处理其他页面
          // 从 localStorage 获取对应的数据
          const dataKey = configKeys[item.pageName];
          const data = localStorage.getItem(dataKey);
          if (data) {
            try {
              const cleanedData = this.cleanEmptyStrArrObj(JSON.parse(data));
              const key = getKeyForPageName(item.pageName); // 获取转换后的键名
              commonData[key] = { ...cleanedData, id: index + 1 }; // 将处理后的数据添加到 commonData 中
            } catch (error) {
              console.error(`Error parsing data for ${item.pageName}:`, error);
            }
          }
        }
      });
      return commonData;
    },
    // 导出二维码
    async handleDownLoadCustomQRCodeImg() {
      // 校验 mobileButler 联动必填字段
      const mobileButlerRef = this.$refs.mobileButler;
      const mobileButlerInstance = Array.isArray(mobileButlerRef) ? mobileButlerRef[0] : mobileButlerRef;
      if (mobileButlerInstance && typeof mobileButlerInstance.validateRequiredFields === 'function' && !mobileButlerInstance.validateRequiredFields()) {
        return;
      }
      this.qrCodeTitle = this.$t('messageAdd.custom.040');
      const commonData = this.handleCustomData();
      if (commonData && Object.keys(commonData).length > 0) {
        const commonDataStr = JSON.stringify(commonData);
        const qrCodeArr = txtToQRtxt(commonDataStr, '<stn2>');
        if (qrCodeArr.length > 0) {
          const date = new Date();
          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          const day = date.getDate();
          const dayStr = year + '' + '0' + month + '' + day;
          const zip = new JSZip();
          const img = zip.folder(`config_${dayStr}`);
          const myNoteName = 'offlineConfigZip';
          for (let i = 0; i < qrCodeArr.length; i++) {
            const url = await QRCode.toDataURL(qrCodeArr[i], {
              width: 200,
              margin: 1,
            });
            const image = url.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');
            const imagesName = `${this.qrCodeTitle} ${i + 1}.png`;
            img?.file(imagesName, image, { base64: true });
          }
          const content = await zip.generateAsync({ type: 'blob' });
          FileSaver.saveAs(content, `${myNoteName}.zip`);
        } else {
          console.log('没有配置');
        }
      } else {
        this.$message.closeAll();
        this.$message.error(this.$t('messageAdd.note.002'));
      }
    },
    // 下载文件
    handleDownLoadCustomQrCodeFile() {
      // 校验 mobileButler 联动必填字段
      const mobileButlerRef = this.$refs.mobileButler;
      const mobileButlerInstance = Array.isArray(mobileButlerRef) ? mobileButlerRef[0] : mobileButlerRef;
      if (mobileButlerInstance && typeof mobileButlerInstance.validateRequiredFields === 'function' && !mobileButlerInstance.validateRequiredFields()) {
        return;
      }
      const commonData = this.handleCustomData();
      if (commonData && Object.keys(commonData).length > 0) {
        downFileData('Config_stn2.json', JSON.stringify(commonData));
      } else {
        this.$message.closeAll();
        this.$message.error(this.$t('messageAdd.custom.041'));
      }
    },
    // 处理dataWedge数据
    handleDataWedgeQrCodeData(qrCodeDataArray) {
      const dArr = []
      qrCodeDataArray.forEach((item) => {
        // 箭头函数避免this指向windows
        if (item && item.content) {
          let c = this.removeEmptyAttrForDataWedge(item.content);
          dArr.push(c)
        } else {
          console.log('没有找到content属性');
        }
      });
      return dArr;
    },
    // 清空空对象和空数组(递归)
    removeEmptyAttrForDataWedge(obj) {
      Object.keys(obj).forEach((key) => {
        if (obj[key] && typeof obj[key] === 'object') {
          this.removeEmptyAttrForDataWedge(obj[key]);
          if (
            Object.keys(obj[key]).length === 0 ||
            (Array.isArray(obj[key]) && obj[key].length === 0)
          ) {
            delete obj[key];
          }
          // 删除id和indexs值
          else if (key === 'id' || key === 'indexs' || key === 'codeTypeFilterCopy') {
            delete obj[key];
          }
        }
        else if (
          (obj[key] === '' || obj[key] === null || obj[key] === undefined) &&
          !(key === 'replace' && obj['source']) // 不删除 profileItemInfos 中的空 replace 字段
        ) {
          delete obj[key];
        }
      });
      return obj;
    },
    // 处理空数据(数组，对象，字符串)一级
    cleanEmptyStrArrObj(data) {
      const result = {};
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          const value = data[key];
          if (Array.isArray(value) && value.length === 0) {
            // 如果是空数组，则不添加到结果对象中
          } else if (typeof value === 'object' && value !== null && Object.keys(value).length === 0) {
            // 如果是空对象，则不添加到结果对象中
          } else if (typeof value === 'string' && value === "") {
            // 如果是空字符串，则不添加到结果对象中
          } else {
            // 否则，添加到结果对象中
            result[key] = value;
          }
        }
      }
      return result;
    },
    // 调用展示二维码信息组件
    customFatherPagePreviewQRCode() {
      // 校验 mobileButler 联动必填字段
      const mobileButlerRef = this.$refs.mobileButler;
      const mobileButlerInstance = Array.isArray(mobileButlerRef) ? mobileButlerRef[0] : mobileButlerRef;
      if (mobileButlerInstance && typeof mobileButlerInstance.validateRequiredFields === 'function' && !mobileButlerInstance.validateRequiredFields()) {
        return;
      }
      // 从本地取出各个页面的数据并整合
      const commonData = this.handleCustomData();
      if (commonData && Object.keys(commonData).length > 0) {
        // 将对象转为字符串，因为二维码内容不能直接展示对象
        const commonQRtxt = {
          ...commonData
        }
        const commonDataStr = JSON.stringify(commonQRtxt);
        this.qrCodeTxt = commonDataStr;
        this.qrCodeTitle = this.$t('messageAdd.custom.040');
        this.isQRCodeVisible = true; // 显示二维码
      } else {
        this.$message.closeAll();
        this.$message.error(this.$t('messageAdd.custom.041'));
      }
    },
    // 预览文件
    handlePreviewCustomQrCodeFile() {
      // 校验 mobileButler 联动必填字段
      const mobileButlerRef = this.$refs.mobileButler;
      const mobileButlerInstance = Array.isArray(mobileButlerRef) ? mobileButlerRef[0] : mobileButlerRef;
      if (mobileButlerInstance && typeof mobileButlerInstance.validateRequiredFields === 'function' && !mobileButlerInstance.validateRequiredFields()) {
        return;
      }
      // 从本地取出各个页面的数据并整合
      const customData = this.handleCustomData();
      console.log('customData', customData);
    },
    redirectToPageA() {
      this.$router.push({ name: 'CustomConfigMode' });
    },
  },
  created() {
    if (this.$route.params && this.$route.params.pages) {
      this.pages = this.$route.params.pages;
      if (this.pages.length > 0) {
        this.activeName = this.pages[0].pageName;
      } else {
        // 如果pages是空数组，则跳转回页面A
        this.redirectToPageA();
      }
    } else {
      this.redirectToPageA();
    }
    // 获取路由参数id,name
    this.savePlanId = this.$route.params.id;
    this.saveName = this.$route.params.name;
  }
};
</script>
